<template>
    <div class="result-slider-wrapper">
        <button type="button" class="icon-arrow3--left restart-button fixed" @click="onClickBack()">
            <span class="sr-only">Move back</span>
        </button>

        <div class="result-slider" ref="resultSlider">
            <div class="configured-product">
                <VueSlickCarousel v-bind="sliderSettings" ref="resultCarousel" @beforeChange="onBeforeChange">
                    <image-layer v-for="(image, idx) in images" :wrapperClass="(idx === currentSlide) ? 'result-slider-image selected' : 'result-slider-image'" :image="image"></image-layer>
                </VueSlickCarousel>
            </div>

            <div class="configurator-slider-indicator">
                <span class="configurator-current-slide" :style="'left: ' + indicatorLeft + 'px; width: ' + indicatorWidth + 'px'"></span>
            </div>

            <slider-controls
                :showLeftArrow="showLeftArrow"
                :showRightArrow="showRightArrow"
                :showArrowBackground="true"
                @clickArrowLeft="onClickArrowLeft()"
                @clickArrowRight="onClickArrowRight()">
            </slider-controls>
        </div>
    </div>
</template>

<script src="./result-slider.js"></script>
